/**
 * FAQ structure. Use with useTranslation: map questionKey/answerKey through t() and pass to QandA.
 * Add new entries here to show more Q&A items.
 */
export const faqCategories = [
  {
    categoryKey: 'faq.categoryGeneral',
    questions: [
      { questionKey: 'faq.q1', answerKey: 'faq.a1' },
      { questionKey: 'faq.q2', answerKey: 'faq.a2' },
      { questionKey: 'faq.q3', answerKey: 'faq.a3' },
      { questionKey: 'faq.q4', answerKey: 'faq.a4' },
      { questionKey: 'faq.q5', answerKey: 'faq.a5' },
    ],
  },
];
